import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { useEffect } from 'react';

export function Initial() {
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        const subdomain = window.location.hostname.split(".");
        if(subdomain && subdomain[0] && !subdomain[0].includes('web')){
            navigate(`/${window.btoa(subdomain[0])}`)
        }
    }, [])

    return (
        <div className="home">
            <Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
        </div>
    )
}